import * as s from './styles';

import type { IGatsbyImageData } from 'gatsby-plugin-image';
import type { IProductsCard } from './types';

const convertName = (classText: string) => classText
  .replace(/([a-z])([A-Z])/g, '$1-$2')
  .replace(/[\s_]+/g, '-')
  .toLowerCase();

const ProductsCard = ({ buttonText, buttonUrl, hoverImage, mainImage, text }: IProductsCard) => {
  return (
    <s.StyledProductsCard
      tabIndex={0}
      aria-label={`text: ${text}, image: ${mainImage.altText}`}
      href={buttonUrl}
    >
      <s.StyledButton>
        {buttonText}
      </s.StyledButton>
      <s.TextContainer>
        <s.SubHeadline>
            {text}
        </s.SubHeadline>
      </s.TextContainer>
      <s.ImageTextContainer>
        <s.ImageContainer>
          <s.CardImageContainer>
            <s.CardImage imageData={mainImage.gatsbyImage as IGatsbyImageData} altText={mainImage?.altText} />
          </s.CardImageContainer>
          <s.HoverContainer className={`${convertName(buttonText)}-hover-img`}>
            <s.HoverCardImage imageData={hoverImage.gatsbyImage as IGatsbyImageData} />
          </s.HoverContainer>
        </s.ImageContainer>
      </s.ImageTextContainer>
    </s.StyledProductsCard>
  );
};

export default ProductsCard;
